const actionsBrokers = () => {
    const dataBrokers = JSON.parse(document.querySelector('[data-how-to-buy]').dataset.howToBuy);
    const dataBrokersStyle = document.querySelector('[data-how-to-buy]').dataset.howToBuyType;
    const howToBuyBrokersContainer = document.getElementById('how-to-buy-brokers');
    const savingsPlanText = howToBuyBrokersContainer.dataset.savingsText;
    const selectBrokersCountry = document.querySelector('#brokersCustomSelect');
    const listOption = selectBrokersCountry.querySelector('.select-options');
    const dataSelectCountryElement = selectBrokersCountry.querySelector('[data-selected-option-value]');
    const dataSelectedCountry = dataSelectCountryElement.dataset.selectedOptionValue;

    const brokerItem = (name, logo, homepage_url, is_saving) => {
        const parentID = name.replace(/[^a-zA-Z0-9]/g, '');
        let savings_star = '';
        if (is_saving) {
            savings_star = `
            <div class="savings__wrapper" id="${parentID}Wrapper">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" fill="none"
            data-toggle="popover"
            data-placement="top"
            data-trigger="hover focus" 
            data-container="#${parentID}Wrapper"
            data-content="${savingsPlanText}"
            ><path d="M9.47693 4.12536L13.2652 4.69908C13.5831 4.75372 13.848 4.97228 13.9539 5.30013C14.0599 5.60065 13.9804 5.95581 13.742 6.17438L10.9869 8.98836L11.6492 12.9771C11.7022 13.305 11.5697 13.6328 11.3048 13.824C11.0399 14.0426 10.6955 14.0426 10.4041 13.906L7.01325 12.0209L3.59588 13.906C3.33096 14.0426 2.96009 14.0426 2.72167 13.824C2.45675 13.6328 2.3243 13.305 2.37728 12.9771L3.01307 8.98836L0.257981 6.17438C0.0195599 5.95581 -0.0599138 5.60065 0.0460511 5.30013C0.152016 4.97228 0.416928 4.75372 0.734823 4.69908L4.54956 4.12536L6.245 0.491764C6.37746 0.191242 6.66886 0 7.01325 0C7.33114 0 7.62254 0.191242 7.755 0.491764L9.47693 4.12536Z" fill="#39DB80"/>
            </svg>
            </div>`;
        }
        return `
      <li class="participants__card">
      ${savings_star}
        <a href="${homepage_url}" target="_blank">
          <img loading="lazy" src="${logo}" alt="${name}">
        </a>
      </li>
    `;
    };

    const largeBanner = (broker) => {
        return `
      <li class="participants__card participants__card_large">
        <a href="${broker.homepage_url}" target="_blank">
        <picture>
        <source srcset="${broker.large_banner.desktop}" media="(min-width: 992px)">
        <img src="${broker.large_banner.mobile}">
        </picture>
        </a>
      </li>
    `;
    };

    const renderBrokers = (selectedValue) => {
        const valueCountry = () => {
            if (selectedValue === 'other' || selectedValue === 'us' || selectedValue === 'ca') {
                return 'ie';
            } else {
                return selectedValue;
            }
        };

        const currentSelectedCountryBrokers = dataBrokers[valueCountry()];

        const compareBrokers = (a, b) => {
            const aOrder = parseInt(a.order);
            const bOrder = parseInt(b.order);

            if (aOrder < bOrder) return -1;
            if (aOrder > bOrder) return 1;

            return a.name.localeCompare(b.name);
        }
        const sortCurrentSelectedCountryBrokers = currentSelectedCountryBrokers.sort(compareBrokers);

        sortCurrentSelectedCountryBrokers.forEach((country) => {
            let logo = dataBrokersStyle ? dataBrokersStyle : 'light';
            if (country.large_banner) {
                howToBuyBrokersContainer.insertAdjacentHTML('afterbegin', largeBanner(country));
            } else {
                howToBuyBrokersContainer.insertAdjacentHTML('beforeend', brokerItem(country.name, country['img']['framed'][logo], country.homepage_url, country.is_saving));
            }
        })
    };

    $(document.body).on('mouseenter mouseleave', '.participants__card svg', function (e) {
        if (e.type === 'mouseenter') {
            $(this).popover('show');
        } else {
            $(this).popover('hide');
        }
    });

    renderBrokers(dataSelectedCountry);

    const showSavingsHint = (entries, hintObserver) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;

        hintObserver.disconnect();

        const firstSavingsIcon = howToBuyBrokersContainer.querySelector('.participants__card svg');

        if (!firstSavingsIcon) return;

        const firstPopover = $(firstSavingsIcon).popover('show');

        setTimeout(function () {
            firstPopover.popover('hide');
        }, 3000);
    };

    new IntersectionObserver(showSavingsHint).observe(howToBuyBrokersContainer);

    const checkChangedAttributes = function (mutationsList, observer) {
        for (const mutation of mutationsList) {
            if (mutation.type === 'attributes' && mutation.attributeName === 'data-selected-option-value') {
                const newValue = mutation.target.dataset.selectedOptionValue;

                updateBrokerList(newValue);
            }
        }
    };

    const observer = new MutationObserver(checkChangedAttributes);
    observer.observe(dataSelectCountryElement, { attributes: true });

    const updateBrokerList = (selectedValue) => {
        howToBuyBrokersContainer.textContent = '';

        renderBrokers(selectedValue);
    };
}

document.addEventListener('DOMContentLoaded', () => {
    window.howToBuyBrokersSelect = new CustomSelect('#brokersCustomSelect');
    actionsBrokers();
})